import { cn } from '../../lib/utils'
import { pagePanel, pagePanelBody, pagePanelHeader } from './page-styles'

interface PagePanelProps {
  children: React.ReactNode
  className?: string
  bodyClassName?: string
  padding?: boolean
}

export function PagePanel({
  children,
  className,
  bodyClassName,
  padding = false,
}: PagePanelProps) {
  return (
    <div className={cn(pagePanel, padding && pagePanelBody, className, bodyClassName)}>
      {children}
    </div>
  )
}

interface PagePanelHeaderProps {
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function PagePanelHeader({ title, description, action, className }: PagePanelHeaderProps) {
  return (
    <div className={cn(pagePanelHeader, className)}>
      <div className='flex flex-col gap-3 md:flex-row md:items-center md:justify-between'>
        <div>
          <h2 className='text-base font-semibold text-neutral-900'>{title}</h2>
          {description ? (
            <div className='text-xs text-neutral-600 mt-1'>{description}</div>
          ) : null}
        </div>
        {action}
      </div>
    </div>
  )
}
